import { AnalyticsBrandSettings, AnalyticsEventData } from 'idt-analytics-api/models';
import { getDefaultAnalytics } from '../helpers/events.helper';
import { AnalyticsGTMSettings, DefaultAnalyticsSettings } from 'analytics-api';
import { AnalyticsOyshoEventDataHelpers } from '../helpers/brand-analytics-event-data.helpers.oy';

export const NewsletterPopupEvents: AnalyticsBrandSettings = {

  popupNewsletterNewsletterIrASuscripcionNewsletter(data: AnalyticsEventData): AnalyticsGTMSettings {
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'newsletter', 'popup_newsletter', 'ir_a_suscripcion_newsletter');
    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },

  popupNewsletterNewsletterSuscripcionPopupRechaza(data: AnalyticsEventData): AnalyticsGTMSettings {
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'newsletter', 'popup_newsletter', 'suscripcion_popup_rechaza');
    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },

};